import React from 'react';

import Input from '../../../../components/inputs/Input';
import Button from '../../../../components/buttons/Button';

import { EditAddress } from './transformToEditOrderRequestObject';
import { InternalAddress } from '../../../../types/orderTypes';

export default function EditableAddress({
  header,
  name,
  email,
  streetName,
  streetNumber,
  postalCode,
  city,
  country = 'Norge',
  areaCode = '+47',
  phone,
  updateAddress,
  hubAddress,
}: {
  header: string;
  name: string;
  email: string;
  streetName: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  country?: string;
  areaCode?: string;
  phone: string;
  updateAddress: (edit: Partial<EditAddress>) => void;
  hubAddress?: InternalAddress;
}) {
  return (
    <div className="order__address order__address-editable">
      <h5>{header}</h5>
      <div className="address-line">
        <span>Name:</span>
        <Input
          onChange={event => updateAddress({ name: event.target.value })}
          value={name}
          placeholder="Name"
          containerStyle={{ width: '80%' }}
        />
      </div>
      <div className="address-line">
        <span>Email:</span>
        <Input
          onChange={event => updateAddress({ email: event.target.value })}
          value={email}
          placeholder="Email"
          containerStyle={{ width: '80%' }}
        />
      </div>
      <div className="address-line">
        <span>Address:</span>
        <Input
          onChange={event => updateAddress({ streetName: event.target.value })}
          value={streetName}
          placeholder="Street name"
          containerStyle={{ width: '55%' }}
        />
        <div style={{ width: '1%' }} />
        <Input
          onChange={event =>
            updateAddress({ streetNumber: event.target.value })
          }
          value={streetNumber}
          placeholder="Street number"
          containerStyle={{ width: '24%' }}
        />
      </div>
      <div className="address-line">
        <span />
        <Input
          onChange={event => updateAddress({ postalCode: event.target.value })}
          value={postalCode}
          placeholder="Postal code"
          containerStyle={{ width: '19%' }}
        />
        <div style={{ width: '1%' }} />
        <Input
          onChange={event => updateAddress({ city: event.target.value })}
          value={city}
          placeholder="City"
          containerStyle={{ width: '29%' }}
        />
        <div style={{ width: '1%' }} />
        <Input
          onChange={event => updateAddress({ country: event.target.value })}
          value={country}
          placeholder="Country"
          containerStyle={{ width: '30%' }}
        />
      </div>
      <div className="address-line">
        <span>Phone:</span>
        <Input
          onChange={event => updateAddress({ areaCode: event.target.value })}
          value={areaCode}
          placeholder="Area code"
          containerStyle={{ width: '10%' }}
        />
        <div style={{ width: '1%' }} />
        <Input
          onChange={event => updateAddress({ phone: event.target.value })}
          value={phone}
          placeholder="Phone number"
          containerStyle={{ width: '69%' }}
        />
      </div>
      {hubAddress && (
        <div style={{ marginTop: 10 }}>
          <Button
            title="Change to hub"
            onClick={() =>
              updateAddress({
                streetName: hubAddress.streetName,
                streetNumber: hubAddress.streetNumber,
                postalCode: hubAddress.postalCode,
                city: hubAddress.city,
                country: hubAddress.country,
              })
            }
          />
        </div>
      )}
    </div>
  );
}
